import Vue from 'vue'
import VueStorage from 'vue-ls'
// import config from '@/config/defaultSettings'

import Element from 'element-ui'
// base library
import Antd from 'ant-design-vue'

import { Modal ,message } from 'ant-design-vue'
Vue.prototype.$confirmAnt = Modal.confirm
Vue.prototype.$Modal = Modal
Vue.prototype.$messageAnt = message
//数据可视化工具
// import Viser from 'viser-vue'
import VueCropper from 'vue-cropper'//图片剪切
import 'element-ui/lib/theme-chalk/index.css'
import 'ant-design-vue/dist/antd.css'

// ext library
import VueClipboard from 'vue-clipboard2'

// import '@/components/use'
import './directives/action'

import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueContextMenu from 'vue-contextmenu'
import vcolorpicker from 'vcolorpicker'

VueClipboard.config.autoSetContainer = true
Vue.use(Element)

Vue.use(Antd)
// Vue.use(Viser)

// Vue.use(VueStorage, config.storageOptions)
Vue.use(VueClipboard)
Vue.use(VueCropper)

Vue.use(VueContextMenu)

Vue.use(vcolorpicker)
Vue.use(VueQuillEditor, /* { default global options } */)
